/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ActionInputs */

const en_footer_action = /** @type {(inputs: Footer_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take Action`)
};

/**
* | output |
* | --- |
* | "Take Action" |
*
* @param {Footer_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action = /** @type {((inputs?: Footer_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action(inputs)
});